import { useTranslation } from 'react-i18next'
import { Badge } from '../ui/badge'
import { percent, recoverableKey, type RecoverableProposal } from '../../hooks/useRecoverableCharges'

export type ListedExpense = { uid?: string; recoverable?: boolean | null; recoverable_ratio?: number | null; recoverable_proposal?: RecoverableProposal }

/**
 * The recoverable chip of a list row (spec 2026-10-25-09): the decision as a
 * solid badge, a proposal nobody confirmed yet as an amber `warning` badge
 * reading « proposed: … » (the review-terms « unconfirmed » treatment), or
 * nothing. Never a dashed border: that is a drop target (patterns §11).
 */
export function RecoverableChip({ expense }: { expense: ListedExpense }) {
  const { t } = useTranslation('expenses')
  const p = expense.recoverable_proposal
  if (expense.recoverable != null) {
    const key = recoverableKey(expense.recoverable, expense.recoverable_ratio)
    return (
      <Badge variant={expense.recoverable ? 'default' : 'secondary'} className="text-xs font-normal" data-testid={`expense-recoverable-chip-${expense.uid}`}>
        {t(`recoverable.chip_${key}`, { percent: percent(expense.recoverable_ratio) })}
      </Badge>
    )
  }
  if (p?.status === 'proposed') {
    const key = recoverableKey(p.recoverable, p.recoverable_ratio)
    return (
      <Badge variant="warning" className="text-xs font-normal" data-testid={`expense-recoverable-chip-${expense.uid}`}>
        {t(`recoverable.chip_proposed_${key}`, { percent: percent(p.recoverable_ratio) })}
      </Badge>
    )
  }
  return null
}
